import { useQuery } from 'react-query';
import { get } from 'Core/utils/platformApi';
import cacheKeys from 'Core/hooks/queries/cacheKeys';
import useAlertStore, { setErrorAlertSelector } from 'Core/stores/alert';
import { useTranslation } from 'react-i18next';

export default function useGetNextStep(customerGid, externalReferenceId, enabled = false) {
  const { t } = useTranslation();
  const setErrorAlert = useAlertStore(setErrorAlertSelector);

  const isEnabled = Boolean(enabled && customerGid && externalReferenceId);

  return useQuery(
    [cacheKeys.easyCreditNextStep, customerGid, externalReferenceId],
    () => {
      return get('/financing/applications/next-step', {
        headers: {
          customer_gid: customerGid,
          external_reference_id: externalReferenceId,
        },
      });
    },
    {
      enabled: isEnabled,
      retry: 1,
      onError(error) {
        setErrorAlert(
          t('status.error.getNextStepFailed') + ` (${error?.response?.data?.message || error.message})`
        );
      },
    }
  );
}

